"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var react_redux_1 = require("react-redux");
var content_1 = require("../../../ProductsApp/ducks/content");
var banners_1 = __importDefault(require("../../banners"));
var GenericButton_1 = __importDefault(require("../../../common/GenericButton"));
var AboutCompany = function () {
    var content = (0, react_redux_1.useSelector)(content_1.contentSelector);
    var titles = (0, react_redux_1.useSelector)(content_1.titleOfContentSelector);
    var seoH1Text = content.seo.h1Text;
    var isMissingTitle = ~titles.titleCase.indexOf('translation missing');
    var seoDescription = content.seo.regularTextHtml;
    // @ts-ignore
    var bannerSrc = banners_1.default[content.name]
        ? // @ts-ignore
            banners_1.default[content.name].default.banner
        : '';
    // @ts-ignore
    var bannerTemplateInfo = banners_1.default[content.name]
        ? // @ts-ignore
            banners_1.default[content.name].default.desc
        : '';
    return (react_1.default.createElement(styles_1.default.Wrapper, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.default.Title, null, !seoH1Text
                ? isMissingTitle
                    ? 'Печать принтов, рисунков, надписей и фотографий'
                    : "".concat(titles.base, " \u0441 \u043F\u0440\u0438\u043D\u0442\u043E\u043C \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")
                : seoH1Text),
            react_1.default.createElement(styles_1.default.RightBlock, { dangerouslySetInnerHTML: {
                    __html: seoDescription || bannerTemplateInfo || ''
                } }),
            react_1.default.createElement(GenericButton_1.default, { style: { marginTop: 16 }, onClick: function () {
                    var _a;
                    return (_a = document
                        .getElementById('cta-form')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                } }, "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443")),
        bannerSrc && react_1.default.createElement(styles_1.default.Image, { src: bannerSrc })));
};
exports.default = AboutCompany;
